import { DateTime } from "luxon";
import * as React from "react";
import { connect } from "react-redux";
import { IState } from "../../../data/reducers/state";
import { IPerson } from "../../../types/persons/person";
import { IIntervalTree } from "../../../util/IntervalTree";

interface IRefereesBreakCellProps {
  persons: string[];
  start: DateTime;
  finish: DateTime;
  span: number;

  availabilities: { [person: string]: IIntervalTree };
  personsMap: { [person: string]: IPerson };
}

const RefereesBreakCell: React.FunctionComponent<IRefereesBreakCellProps> = ({
  persons,
  span,
  start,
  finish,
  availabilities,
  personsMap,
}) => {
  const interval = { low: start.valueOf(), high: finish.valueOf() };
  // const beforeInterval = { low: start.minus({ minutes: 40 }).valueOf(), high: start.valueOf() }
  const availablePersons: string[] = [];

  return (
    <td
      rowSpan={span}
      style={{
        borderBottom: "solid 1px black",
        borderTop: "solid 1px black",
        verticalAlign: "top",
        paddingTop: "15px",
      }}
    >
      {/* <p>avail cell map</p>
        {availablePersons
            .filter(p => !IntervalTree.hasOverlap(availabilities[p], interval))
            .map(p => <p style={{ marginBottom: "5px", paddingBottom: "0" }} key={`avail-list-${start}-${p}`}>{personsMap[p].fullName}</p>)} */}
    </td>
  );
};

const mapStateToProps = (
  state: IState,
  props: IRefereesBreakCellProps,
): Partial<IRefereesBreakCellProps> => ({
  // map availabilities ID list to actual availabilities
  availabilities: state.availabilities.tree,
  personsMap: state.persons.map,
});
export default connect(mapStateToProps)(RefereesBreakCell);
